import { StoryblokLinkComponent } from '@cinch-nx/data-storyblok'
import { LinkList } from '@cinch-nx/shared-ui'

import styles from './links-section.module.css'

export type Props = {
  title: string
  links: StoryblokLinkComponent[]
}

export const LinksSection: React.FC<Props> = ({ title, links }) => {
  const models = links?.map((p: StoryblokLinkComponent) => ({
    url: p.url.url,
    text: p.text,
  }))

  return (
    <section className={styles.container}>
      <LinkList title={title} linkItems={models} />
    </section>
  )
}
